export default __webpack_public_path__ + "static/intermot-bcf73cbf546d342d7d59db68715a01d1.jpg";